export type AuthLevelRequired = Array<Level> | false

export enum Level {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}
